var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "mr-10 overflow-visible",
    width: 16.3,
    height: 18.75,
    viewBox: "0 0 28 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2377 16.9273C23.2377 14.2847 24.4958 12.3562 26.938 10.8563C25.5319 8.92792 23.4598 7.92799 20.7216 7.71372C18.0574 7.49945 15.1711 9.14219 14.1351 9.14219C13.025 9.14219 10.5088 7.78514 8.51064 7.78514C4.36633 7.85657 4.77668e-08 10.9278 7.55527e-08 17.2844C8.36699e-08 19.1415 0.296022 21.0699 1.03608 23.0697C1.99815 25.7124 5.40241 32.1405 8.95467 31.9977C10.8048 31.9977 12.1369 30.712 14.5791 30.712C16.9473 30.712 18.1314 31.9977 20.2035 31.9977C23.8298 31.9977 26.938 26.1409 27.8261 23.4983C23.0157 21.2842 23.2377 17.0702 23.2377 16.9273ZM19.0934 5.2139C21.0916 2.92836 20.8696 0.785657 20.8696 8.68795e-08C19.0934 0.142847 17.0213 1.2142 15.8372 2.49982C14.5051 3.92828 13.765 5.71387 13.913 7.6423C15.8372 7.78514 17.6133 6.85664 19.0934 5.2139Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleIcon);
export default __webpack_public_path__ + "static/media/apple-icon.5c81c557edd74249e517efe53ea6594a.svg";
export { ForwardRef as ReactComponent };